import { Buffer } from "buffer";
export const encode = (string) => {
  return Buffer.from(string).toString("base64");
};
export const decode = (string) => {
  return Buffer.from(string, "base64").toString("utf-8");
};
